export default __webpack_public_path__ + "static/media/done.60841e3e.svg";